// Ngày theo GIỜ ĐỊA PHƯƠNG dạng yyyy-mm-dd.
// Không dùng `new Date().toISOString().slice(0, 10)` vì đó là ngày UTC: ở Việt Nam (UTC+7),
// từ 00:00 đến 07:00 sáng nó trả về "hôm qua" → form tạo đơn mặc định sai ngày.
export function localDateStr(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
